import React from 'react';
import { toCurrency } from '../utils/helper';
import dayjs from 'dayjs';

// Helper function to access nested object properties
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, key) => {
    return current ? current[key] : null;
  }, obj);
};

const Table = ({ headers, items = {}, loading = false, refetch }) => {
  const itemsArray = Array.isArray(items) ? items : Object.values(items);

  return (
    <div className='relative overflow-x-auto rounded-lg border border-slate-200 max-h-[500px]'>
      <table className='w-full text-sm text-left'>
        <thead className='text-xs text-gray-700 uppercase bg-gray-50 border-b sticky top-0 z-10'>
          <tr>
            {headers.map((header) => (
              <th
                key={header.key}
                scope='col'
                className={`px-3 py-2 first:sticky first:left-0 first:bg-gray-50 first:z-20 ${
                  header.print === false ? 'print:hidden' : ''
                }`}
                style={{ minWidth: header.width || '180px' }}
              >
                {header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!loading ? (
            itemsArray.length > 0 ? (
              itemsArray.map((item, index) => (
                <tr
                  key={index}
                  className='bg-white border-b last:border-0 hover:bg-gray-50'
                >
                  {headers.map((header) => (
                    <td
                      key={header.key}
                      className={`px-3 py-2 align-top first:sticky first:left-0 first:bg-white first:z-20 ${
                        header.print === false ? 'print:hidden' : ''
                      }`}
                    >
                      {header.type === 'currency' ? (
                        <>
                          ₱{toCurrency(getNestedValue(item, header.key) || 0)}
                        </>
                      ) : header.type === 'number' ? (
                        getNestedValue(item, header.key)?.toFixed(2)
                      ) : header.type === 'date' ? (
                        dayjs(getNestedValue(item, header.key)).format(
                          'MMM DD, YYYY'
                        )
                      ) : header.type === 'time' ? (
                        dayjs(getNestedValue(item, header.key), 'HH:mm').format(
                          'h:mm A'
                        )
                      ) : header.type === 'status' ? (
                        <span
                          className={`px-2 py-1 font-semibold leading-tight rounded-full ${
                            getNestedValue(item, header.key)?.class || ''
                          }`}
                        >
                          {getNestedValue(item, header.key)?.text}
                        </span>
                      ) : header.type === 'custom' ? (
                        header.customCell?.({ item, refetch })
                      ) : (
                        getNestedValue(item, header.key)
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr className='bg-white '>
                <td colSpan={headers.length} className='px-3 py-2 text-center'>
                  No data available
                </td>
              </tr>
            )
          ) : (
            <tr className='bg-white'>
              <td colSpan={headers.length} className='px-3 py-2 text-center'>
                Loading...
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
